import { createWebHistory, createRouter } from 'vue-router'

/* Layouts */
import App from '@layouts/App.vue'

/* Pages */
import Activation from '@pages/Activation.vue'
import Terms from '@pages/Terms.vue'

/* Routes */
const routes = [
	{
		path: '/',
		component: App,
		children: [
			{ path: '', name: 'index', component: Activation },
			{ path: '/terms/:slug', name: 'terms', component: Terms },
			{
				path: (() => {
					try {
						const activation = document.body.getAttribute('data-activation')
						if (!activation) return '/'
						const parsed = JSON.parse(activation)
						return parsed?.path || '/'
					} catch (e) {
						return '/'
					}
				})(),
				name: 'activation',
				component: Activation,
			},
			{
				path: '/:catchAll(.*)',
				name: '404',
				redirect: { name: 'index' },
			},
		],
	},
]

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		if (to.name == from.name && !to.hash) {
			return { top: 0, behavior: 'smooth' }
		} else if (to.hash) {
			return {
				el: to.hash,
				top: 100,
				behavior: 'smooth',
			}
		} else {
			return {
				top: 0,
			}
		}
	},
	history: createWebHistory(),
	routes,
})

export default router
